import { combineReducers } from "redux";
import toast from "./toast";

export default combineReducers({ toast });
